import {Injectable} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {ShowTextDialog} from '../../components/dialogs/show-text-dialog/show-text-dialog.component';
import {MatDialog, MatDialogConfig} from '@angular/material/dialog';

@Injectable({
  providedIn: 'root'
})
export class CustomDialogService {
  constructor(private readonly translate: TranslateService, private readonly dialog: MatDialog,) {
  }

  imageUploadError() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.autoFocus = true;
    dialogConfig.data = {
      title: this.translate.instant('image.error.title'),
      text: this.translate.instant('image.error.body'),
      close: this.translate.instant('image.error.ok'),
    };
    this.dialog.open(ShowTextDialog, dialogConfig);
  }

  duplicateFileError() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.autoFocus = true;
    dialogConfig.data = {
      title: this.translate.instant('proposalDetails.createOfferTab.duplicateFileError.title'),
      text: this.translate.instant('proposalDetails.createOfferTab.duplicateFileError.body'),
      close: this.translate.instant('proposalDetails.createOfferTab.duplicateFileError.ok'),
    };
    this.dialog.open(ShowTextDialog, dialogConfig);
  }

  unsupportedFileError() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.autoFocus = true;
    dialogConfig.data = {
      title: this.translate.instant('proposalDetails.createOfferTab.unsupportedFileType.title'),
      text: this.translate.instant('proposalDetails.createOfferTab.unsupportedFileType.body'),
      close: this.translate.instant('proposalDetails.createOfferTab.unsupportedFileType.ok'),
    };
    this.dialog.open(ShowTextDialog, dialogConfig);
  }

}

